$(() => {
  $('.see-more').click(function(){
    $('.truncated').hide();
    $('.untruncated').css({'cssText': 'display: block !important;'});
  })
});